"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loader_1 = __importDefault(require("../Loader"));
var CarsLoadmore = function (_a) {
    var onClick = _a.onClick, willLoadCount = _a.willLoadCount, allUnloadCount = _a.allUnloadCount, isLoading = _a.isLoading;
    return allUnloadCount > 0 ? (react_1.default.createElement("div", { className: "aui-CarsLoadmore" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("button", { className: "aui-CarsLoadmore-btn", onClick: onClick },
                "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0435 ",
                willLoadCount,
                " \u0438\u0437 ",
                allUnloadCount,
                " \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439",
                isLoading &&
                    react_1.default.createElement("div", { className: "aui-CarsLoadmore-loader" },
                        react_1.default.createElement(Loader_1.default, { size: 2 })))))) : null;
};
exports.default = CarsLoadmore;
